module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/payrollSubmissions/Main.html -->\n<div class="wrapper wrapper-content payroll-submission">\n\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                <h5>Payroll submissions</h5>\n                <div class="ibox-tools"><h5>Total Submissions: '+
((__t=( total ))==null?'':_.escape(__t))+
'</h5></div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable footable-ellipsis table table-stripped footable-payroll-submissions" data-striping="false">\n                    <thead>\n                    <tr>\n                        <th style="width: 25%">Company Name</th>\n                        <th style="width: 25%">Payroll State</th>\n                        <th style="width: 50%">Action</th>\n                    </tr>\n                    </thead>\n                    <tbody id="submissions"></tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/payrollSubmissions/Main.html
// module id = 648
// module chunks = 1